import React, { useRef } from 'react';
import styled from 'styled-components';
import Dialog from 'tdesign-react/es/dialog/Dialog';
import SvgIcon from '@/components/SvgIcon';

export default function Modal({ handleCancel, children, header, chartRef, name, unit, ...others }) {
  const ref = useRef();

  const downloadImage = () => {
    const canvas = ref.current.querySelector('canvas');
    const img = new Image();
    const source = canvas.toDataURL();
    img.src = source;
    img.onload = function () {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height + 30;

      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, img.width, img.height + 30);

      ctx?.drawImage(img, 0, 30, img.width, img.height);

      ctx.fillStyle = '#000';
      ctx.font = '20px Arial';
      ctx?.fillText(`${name || ''} ${unit || ''}`, 10, 20);

      const dataURL = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      const event = new MouseEvent('click');
      a.download = name || 'chart.png';
      // 将生成的URL设置为a.href属性
      a.href = dataURL;
      // 触发a的单击事件
      a.dispatchEvent(event);
      a.remove();
    };
  };

  return (
    <Dialog
      width='75%'
      visible
      onCancel={handleCancel}
      onClose={handleCancel}
      header={
        <Header>
          {header}
          <Icon type='download' size={20} onClick={downloadImage} />
        </Header>
      }
      {...others}
    >
      <Body>
        <div ref={ref}>{children}</div>
      </Body>
    </Dialog>
  );
}

const Body = styled.div`
  overflow: hidden;
  .chart-tool-tip {
    padding: 8px 4px;
    > div {
      padding: 4px 0;
    }
  }
`;

const Header = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

const Icon = styled(SvgIcon)`
  cursor: pointer;
  color: var(--td-font-gray-2);
`;
